module.exports = __webpack_public_path__ + "img/z_norms2.1f934fb2.png";